/* ============================================
   OTP 处理 Mixin
   ============================================
   包含 OTP 输入、键盘、粘贴处理的通用逻辑
   用于减少代码重复，便于维护
   ============================================ */

import { handleOtpInput as handleOtpInputUtil, handleOtpKeydown as handleOtpKeydownUtil, handleOtpPaste as handleOtpPasteUtil } from './utils.js';

export default {
  methods: {
    /**
     * 处理 OTP 输入（通用方法）
     * @param {Array} otpArray - OTP 数组（如 this.otpDigits）
     * @param {number} index - 当前输入框索引
     * @param {Event} event - 输入事件
     * @param {Function} onComplete - 完成回调函数（当所有位都填满时调用）
     * @param {Function} clearError - 清除错误的方法
     * @param {string} inputSelector - 输入框选择器（如 '.otp-input'）
     * @param {Object} context - 上下文对象（通常是 this）
     */
    handleOtpInputGeneric(otpArray, index, event, onComplete, clearError, inputSelector = '.otp-input', context = this) {
      const getNextInput = (nextIndex) => {
        if (context.$el) {
          return context.$el.querySelectorAll(inputSelector)[nextIndex];
        }
        return event.target.parentElement?.querySelectorAll(inputSelector)[nextIndex];
      };
      
      handleOtpInputUtil(otpArray, index, event, onComplete, clearError, getNextInput);
    },
    
    /**
     * 处理 OTP 键盘事件（通用方法）
     * @param {Array} otpArray - OTP 数组（如 this.otpDigits）
     * @param {number} index - 当前输入框索引
     * @param {Event} event - 键盘事件
     * @param {string} inputSelector - 输入框选择器（如 '.otp-input'）
     * @param {Object} context - 上下文对象（通常是 this）
     */
    handleOtpKeydownGeneric(otpArray, index, event, inputSelector = '.otp-input', context = this) {
      const getPrevInput = (prevIndex) => {
        if (context.$el) {
          return context.$el.querySelectorAll(inputSelector)[prevIndex];
        }
        return event.target.parentElement?.querySelectorAll(inputSelector)[prevIndex];
      };
      
      handleOtpKeydownUtil(otpArray, index, event, getPrevInput);
    },
    
    /**
     * 处理 OTP 粘贴事件（通用方法）
     * @param {Array} otpArray - OTP 数组（如 this.otpDigits）
     * @param {Event} event - 粘贴事件
     * @param {Function} onComplete - 完成回调函数（当粘贴4位数字时调用）
     * @param {string} inputSelector - 输入框选择器（如 '.otp-input'）
     * @param {Object} context - 上下文对象（通常是 this）
     */
    handleOtpPasteGeneric(otpArray, event, onComplete, inputSelector = '.otp-input', context = this) {
      const getNextInput = (nextIndex) => {
        if (context.$el) {
          return context.$el.querySelectorAll(inputSelector)[nextIndex];
        }
        return null;
      };
      
      handleOtpPasteUtil(otpArray, event, onComplete, getNextInput);
    }
  }
};

